export const GET_UNREAD_MESSAGES_COUNT = 'GET_UNREAD_MESSAGES_COUNT';
export const UPDATE_UNREAD_MESSAGES_COUNT = 'UPDATE_UNREAD_MESSAGES_COUNT';
export const GET_CURRENT_CONVERSATION = 'GET_CURRENT_CONVERSATION';
export const GET_CONVERSATION_LIST = 'GET_CONVERSATION_LIST';
export const HIDE_CHAT_ROOM = 'HIDE_CHAT_ROOM';
export const PIN_CHAT = 'PIN_CHAT';
export const UNPIN_CHAT = 'UNPIN_CHAT';
export const MARK_AS_UNREAD = 'MARK_AS_UNREAD';
export const MARK_AS_READ = 'MARK_AS_READ';
export const CURRENT_CHAT_ROOM_ID = 'CURRENT_CHAT_ROOM_ID';
